import React from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';

export function DashboardDatePicker(props) {
  return (
    <>
      {props.showDatePicker && (
        <DateRangePicker
          required={true}
          onChange={props.setDateRange}
          value={props.dateRange}
          calendarIcon={<FaCalendarAlt />}
          locale={props.dateLocale}
          clearIcon={null}
          showFixedNumberOfWeeks={true}
        />
      )}
    </>
  );
}
